import { proxyAssetsUrl } from '../proxy-assets-url';

export const lotteryAssetsUrlValue: string = `${proxyAssetsUrl}?url=https://static-assets.lvbet.pl/images/other/lv-wheel-v2/animation/letsbetmd/`;
